export default "__VITE_PUBLIC_ASSET__0007ebeb__"